import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["disabled"];
import { reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { createTextAsset } from '@/api/assets';
export default {
  __name: 'AssetTextCreateDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    folderId: {
      type: [Number, String],
      default: null
    },
    tagList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      name: '',
      textContent: '',
      description: '',
      tagIds: []
    });
    const submitting = ref(false);
    async function handleSubmit() {
      submitting.value = true;
      try {
        await createTextAsset({
          folderId: props.folderId,
          name: form.name,
          textContent: form.textContent,
          description: form.description || undefined,
          tagIds: form.tagIds?.length ? form.tagIds : undefined
        });
        ElMessage.success('文本素材创建成功');
        Object.assign(form, {
          name: '',
          textContent: '',
          description: '',
          tagIds: []
        });
        emit('success');
      } catch {
        // handled by interceptor
      } finally {
        submitting.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: "新建文本素材",
        width: "560px",
        "close-on-click-modal": false,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.$emit('update:visible', $event))
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('update:visible', false))
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: !form.name || !form.textContent || submitting.value,
          onClick: handleSubmit
        }, _toDisplayString(submitting.value ? '提交中...' : '创建'), 9, _hoisted_1)]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form,
          "label-width": "80px",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "素材名称",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              placeholder: "输入素材名称",
              maxlength: "200"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "文本内容",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.textContent,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.textContent = $event),
              type: "textarea",
              rows: 10,
              placeholder: "输入文本内容（最大 200KB）",
              maxlength: "204800",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "描述"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.description = $event),
              placeholder: "简要描述",
              maxlength: "1000"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), __props.tagList.length > 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "标签"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.tagIds,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.tagIds = $event),
              multiple: "",
              placeholder: "选择标签",
              class: "w-full",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tagList, tag => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: tag.id,
                  label: tag.name,
                  value: tag.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};